const samlActionTypes = {
  RESET_STATE: 'RESET_STATE',
};

export { samlActionTypes as default };
